var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.245,
    height: 22.891,
    viewBox: "0 0 22.245 22.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17568",
    "data-name": "Group 17568",
    transform: "translate(-107.002 -3751.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "different-currencies",
    transform: "translate(106.359 3751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_129_",
    transform: "translate(0.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17567",
    "data-name": "Group 17567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17562",
    "data-name": "Group 17562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8359",
    "data-name": "Path 8359",
    d: "M10.417,7.706a6.9,6.9,0,0,1,1.226-3.335A5.565,5.565,0,1,0,5.049,11.01a8.345,8.345,0,0,1,5.368-3.3ZM3.982,6.892a.353.353,0,0,1,.358-.359H5.483V6.266L5.327,6H4.34a.359.359,0,1,1,0-.718H4.9l-1.215-2a.806.806,0,0,1-.129-.377.714.714,0,0,1,.791-.672.7.7,0,0,1,.626.433L6.209,5.015,7.442,2.667a.7.7,0,0,1,.625-.433.715.715,0,0,1,.792.672.807.807,0,0,1-.128.377l-1.215,2h.561a.359.359,0,0,1,0,.718H7.092l-.156.267v.267H8.077a.359.359,0,1,1,0,.718H6.936v.911A.679.679,0,0,1,6.21,8.9a.679.679,0,0,1-.727-.736V7.251H4.34a.352.352,0,0,1-.358-.359Z",
    transform: "translate(-0.643)",
    fill: "#3f2566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17563",
    "data-name": "Group 17563",
    transform: "translate(11.192 2.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8360",
    "data-name": "Path 8360",
    d: "M29.128,5.714a5.572,5.572,0,0,0-5.508,4.8,8.3,8.3,0,0,1,3.008.588.389.389,0,0,1,.388-.231h.193a1.714,1.714,0,0,1-.276-.985,2.092,2.092,0,0,1,2.31-1.942c1.612,0,2.394.865,2.394,1.583a.622.622,0,0,1-.691.644c-.81,0-.313-1.123-1.555-1.123a.963.963,0,0,0-1.058.92,2.019,2.019,0,0,0,.3.9h1c.377,0,.571.138.571.442s-.193.441-.571.441H28.9a.584.584,0,0,1,.047.221,1.187,1.187,0,0,1-.094.439,8.391,8.391,0,0,1,.842.812,3.635,3.635,0,0,0,.753.111c.155,0,.535-.1.68-.1a.533.533,0,0,1,.534.588c0,.519-.465.745-.943.776a8.421,8.421,0,0,1,.777,1.7A5.562,5.562,0,0,0,29.128,5.714Z",
    transform: "translate(-23.62 -5.714)",
    fill: "#3f2566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17564",
    "data-name": "Group 17564",
    transform: "translate(11.502 16.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8361",
    "data-name": "Path 8361",
    d: "M24.257,34.076v2.278c.689-.046,1.415-.368,1.415-1.127C25.672,34.444,24.877,34.214,24.257,34.076Z",
    transform: "translate(-24.257 -34.076)",
    fill: "#3f2566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17565",
    "data-name": "Group 17565",
    transform: "translate(9.523 12.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8362",
    "data-name": "Path 8362",
    d: "M20.193,27.449c0,.576.426.908,1.288,1.082v-2.06C20.7,26.5,20.193,26.954,20.193,27.449Z",
    transform: "translate(-20.193 -26.471)",
    fill: "#3f2566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17566",
    "data-name": "Group 17566",
    transform: "translate(4.174 8.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8363",
    "data-name": "Path 8363",
    d: "M16.172,18.429a6.958,6.958,0,1,0,6.959,6.959,6.958,6.958,0,0,0-6.959-6.959ZM16.541,29.5v.714a.348.348,0,1,1-.691,0V29.5c-1.943-.046-2.911-1.208-2.911-2.118a.662.662,0,0,1,.713-.724c1.288,0,.287,1.588,2.2,1.668v-2.4c-1.7-.31-2.737-1.058-2.737-2.336,0-1.564,1.3-2.37,2.737-2.415V20.56a.348.348,0,1,1,.691,0v.613c.9.024,2.736.586,2.736,1.715a.691.691,0,0,1-.725.712c-.748,0-.737-1.229-2.011-1.253v2.186c1.519.322,2.864.771,2.864,2.544C19.4,28.616,18.253,29.4,16.541,29.5Z",
    transform: "translate(-9.213 -18.429)",
    fill: "#3f2566"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.deb69ef553c16ab926c81eae51f31349.svg";
export { ForwardRef as ReactComponent };